import React, { useState } from 'react';
import { Resource, resources } from '../../constants/resources';
import ResourceCard from '../../components/resources/ResourceCard';
import ResourceSpotlight from '../../components/resources/ResourceSpotlight';
import ResourceDetailsModal from '../../components/resources/ResourceDetailsModal';

interface RelatedResourcesProps {
  resourceIds?: string[];
}

interface ModalState {
  resource: Resource | null;
  showPaymentInfo: boolean;
}

const RelatedResources: React.FC<RelatedResourcesProps> = ({ resourceIds }) => {
  const [modalState, setModalState] = useState<ModalState>({ resource: null, showPaymentInfo: false });

  const openResourceDetails = (resource: Resource) => {
    setModalState({ resource, showPaymentInfo: false });
  };

  const openResourcePayment = (resource: Resource) => {
    setModalState({ resource, showPaymentInfo: true });
  };

  const closeModal = () => {
    setModalState({ resource: null, showPaymentInfo: false });
  };

  if (!resourceIds || resourceIds.length === 0) {
    return null;
  }

  // Filter resources that match the IDs provided related to the post
  const relatedResources = resources.filter((resource: Resource) => 
    resourceIds.includes(resource.id)
  );

  if (relatedResources.length === 0) {
    return null;
  }

  // If there is exactly one resource, show the Spotlight version
  if (relatedResources.length === 1) {
    return (
      <>
        <div className="mt-12 mb-8 animate-fade-in">
          <ResourceSpotlight 
            resource={relatedResources[0]} 
            onClick={() => openResourceDetails(relatedResources[0])}
            onBuyClick={() => openResourcePayment(relatedResources[0])}
          />
        </div>
        <ResourceDetailsModal 
          resource={modalState.resource} 
          isOpen={!!modalState.resource} 
          onClose={closeModal}
          initialShowPayment={modalState.showPaymentInfo}
        />
      </>
    );
  }

  // If there are multiple resources, show the Carousel/Grid version
  return (
    <>
      <div className="mt-16 pt-8 border-t border-stone-200">
        <div className="flex items-center justify-between mb-8">
          <h3 className="font-serif text-2xl md:text-3xl text-stone-800">
            Recursos que pueden acompañarte
          </h3>
          {/* Optional: Navigation arrows for carousel could go here */}
        </div>
        
        <div className="flex flex-nowrap md:flex-wrap overflow-x-auto md:overflow-visible pb-8 gap-6 snap-x md:snap-none scrollbar-thin scrollbar-thumb-contessa-200 scrollbar-track-stone-100 px-1 md:px-0 md:justify-center">
          {relatedResources.map((resource) => (
            <ResourceCard 
              key={resource.id} 
              resource={resource} 
              className="min-w-[280px] w-[75vw] md:w-[320px] snap-center border-stone-200 shadow-sm shrink-0"
              onClick={() => openResourceDetails(resource)}
              onBuyClick={() => openResourcePayment(resource)}
            />
          ))}
        </div>
      </div>
      <ResourceDetailsModal 
        resource={modalState.resource} 
        isOpen={!!modalState.resource} 
        onClose={closeModal}
        initialShowPayment={modalState.showPaymentInfo}
      />
    </>
  );
};

export default RelatedResources;
